import { FC, useState } from "react";
import ButtonComponent from "../../../../../common/components/button/button.component";
import ModalComponent from "../../../../../common/components/modal/modal.component";
import orderOptimizerTranslationsHelper from "../../../../../languages/order-optimizer-translations.helper";
import NumericInputComponent from "../../../../../common/components/form/input/numeric-input/numeric-input.component";
import FormFieldComponent from "../../../../../common/components/form/field/form-field.component";
import orderOptimizerTaxiListingMaximumHaltingTimeModalValidationService from "./order-optimizer-taxi-listing-maximum-halting-time-modal-validation.service";

type OrderOptimizerTaxiListingMaximumHaltingTimeModalProps = {
  isOpen: boolean;
  onSuccessClick: () => void;
  onCloseClick: () => void;
  maximumHaltingTimeValue: number | null;
  setMaximumHaltingTimeValue: (value: number) => void;
};

const OrderOptimizerTaxiListingMaximumHaltingTimeModalComponent: FC<
  OrderOptimizerTaxiListingMaximumHaltingTimeModalProps
> = (props) => {
  const translations =
    orderOptimizerTranslationsHelper.getTaxiListingTranslations().filters
      .maximumHaltingTimeModal;

  const [error, setError] = useState<string | null>(null);

  const handleValueChange = (value: number) => {
    props.setMaximumHaltingTimeValue(value);

    const result =
      orderOptimizerTaxiListingMaximumHaltingTimeModalValidationService.validateMaximumHaltingTime(
        value,
      );

    if (!result.isValid) {
      setError(result.errorMessage);
    } else {
      setError(null);
    }
  };

  const handleAcceptClick = () => {
    if (error) return;
    props.onSuccessClick();
  };

  return (
    <ModalComponent
      header={{ title: translations.headingLabel }}
      isOpen={props.isOpen}
      onClose={props.onCloseClick}
      actions={[
        <ButtonComponent
          onClick={handleAcceptClick}
          type="primary"
          title={translations.acceptButtonTitle}
        >
          {translations.acceptButtonLabel}
        </ButtonComponent>,
        <ButtonComponent
          onClick={props.onCloseClick}
          type="danger"
          title={translations.cancelButtonTitle}
        >
          {translations.cancelButtonLabel}
        </ButtonComponent>,
      ]}
    >
      <FormFieldComponent
        label={translations.inputHeadingLabel}
        isRequired
        errorMessage={error ?? undefined}
      >
        <NumericInputComponent
          value={props.maximumHaltingTimeValue}
          onChange={handleValueChange}
          classNames={{ root: "order_optimizer_taxi_listing_filter__input" }}
          isIntegerOnly
          hasError={!!error}
        />
      </FormFieldComponent>
    </ModalComponent>
  );
};

export default OrderOptimizerTaxiListingMaximumHaltingTimeModalComponent;
